import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nav" }
const _hoisted_2 = ["href"]

import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { mainMenu, MenuItem } from '@/constants/menus';
import { ADMIN_PATH } from '@/constants/routes';


export default /*@__PURE__*/_defineComponent({
  __name: 'Desktop',
  setup(__props) {

const store = useStore();
const { t } = useI18n();

const userRole = computed<string>(() => store.getters.role);
const user = computed(() => store.getters.user || '');
const idOrg = computed(() => user.value?.organization?.id);

const changeLinksForOrgRole = () => {
  let items = [];
  items = mainMenu.filter(
    (menuLink) => menuLink.permissions.includes(userRole.value)
  );

  if (!user.value) { return items; }
  if (!idOrg.value) { return items; }

  return items.map((menuLink) => {
    if (menuLink.baseUrlLink?.includes('invoices')) {
      const updatedMenuLink = { ...menuLink };
      updatedMenuLink.baseUrlLink = menuLink.baseUrlLink?.replace('invoices', `organization/${idOrg.value}/orders`);
      return { ...updatedMenuLink };
    } if (menuLink.baseUrlLink?.includes(`/${ADMIN_PATH}/users`)) {
      const updatedMenuLink = { ...menuLink };
      updatedMenuLink.baseUrlLink = menuLink.baseUrlLink?.replace('users', `organization/${idOrg.value}/users`);
      return { ...updatedMenuLink };
    }
    return menuLink;
  });
};

const menu = computed<Array<MenuItem>>(() => changeLinksForOrgRole());

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.value, (element, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: `navLink-${index}`
      }, [
        (!element.baseUrlLink)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: element.link,
              class: "nav__link nav-link__animated-bg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)(element.title)), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: element.baseUrlLink,
              class: "nav__link nav-link__animated-bg"
            }, _toDisplayString(_unref(t)(element.title)), 9, _hoisted_2))
      ], 64))
    }), 128))
  ]))
}
}

})